module.exports = __webpack_public_path__ + "img/icolis_web_big.013052c2.png";